module.exports = __webpack_public_path__ + "img/多边形-亮.d5d7280a.png";